
const navigationSubmenuAttribute = 'data-nav-submenu';
const navigationSubmenuSelector = `[${navigationSubmenuAttribute}]`;
const navigationSubmenuBtns = document.querySelectorAll(navigationSubmenuSelector);

navigationSubmenuBtns.forEach((element, index, parent) => {
  element.addEventListener('click', toggleSubmenu);
});

function toggleSubmenu(event) {
  event.preventDefault();
  let targetSelector = event.currentTarget.getAttribute(navigationSubmenuAttribute);
  let target = document.querySelector(targetSelector);
  target.classList.toggle('open');
}

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    let elements = document.querySelectorAll('.main-nav .open');
    elements.forEach((element, index, parent) => {
      element.classList.remove('open');
    });
  }
});